<template>
  <material-card
    :title="title"
    color="dover-blue">
    <v-form
      ref="form"
      v-model="isValidationOk"
      lazy-validation>
      <v-container
        py-0>
        <v-layout
          wrap>
          <v-flex
            xs12
            md3
            text-xs-left>
            <v-btn-toggle
              v-model="network.dhcp"
              dense
              group
              mandatory>
              <v-btn
                v-for="(item) in networkSettings"
                :key="item.index"
                :value="item.value"
                text
                small
                color="dover-blue">
                {{ item.desc }}
              </v-btn>
            </v-btn-toggle>
          </v-flex>
          <v-flex
            xs12
            md3>
            <v-text-field
              v-if="network.dhcp"
              v-model="network.ip"
              :label="`${ $t('Tcp-Ip').toUpperCase() }`"
              disabled
              counter
              class="dover-input"/>
            <v-text-field
              v-else
              v-model="network.ip"
              :rules="rules.ipAddress"
              :label="`${ $t('Tcp-Ip').toUpperCase() }`"
              counter
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md3>
            <v-text-field
              v-model.number="network.port"
              :rules="rules.required.concat(rules.port)"
              :counter="5"
              :label="`${ $t('Port') }`"
              mask="#####"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md3>
            <v-text-field
              v-if="network.dhcp"
              v-model="network.mask"
              :rules="rules.ipAddress"
              :label="`${ $t('Mask') }`"
              disabled
              counter
              class="dover-input"/>
            <v-text-field
              v-else
              v-model="network.mask"
              :rules="rules.ipAddress"
              :label="`${ $t('Mask') }`"
              counter
              class="dover-input"/>
          </v-flex>
          <v-flex
            v-if="!Maglink.isResponsive"
            xs12
            md3/>
          <v-flex
            xs12
            md3>
            <v-text-field
              v-if="network.dhcp"
              v-model="network.gateway"
              :label="`${ $t('Gateway') }`"
              disabled
              counter
              class="dover-input"/>
            <v-text-field
              v-else
              v-model="network.gateway"
              :rules="rules.ipAddress"
              :label="`${ $t('Gateway') }`"
              counter
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md3>
            <v-text-field
              v-model="network.dns1"
              :rules="rules.ipAddress"
              :label="`${ $t('DNS {0}', ['1']) }`"
              counter
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md3>
            <v-text-field
              v-model="network.dns2"
              :rules="rules.ipAddress"
              :label="`${ $t('DNS {0}', ['2']) }`"
              counter
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md12
            text-xs-right>
            <v-btn
              :disabled="!isValidationOk"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="onSave">
              {{ $t('Save') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>
import Vue from 'vue'
import { i18n } from '@/i18n'

export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isValidationOk: false,
    network: {
      ip: '',
      port: 3000,
      mask: '',
      gateway: '',
      dns1: '8.8.8.8',
      dns2: '8.8.4.4'
    },
    rules: {
      required: [ v => Vue.prototype.Maglink.RulesRequired(v) ],
      port: [ v => Vue.prototype.Maglink.RulesRange(v, 1, 65535) ],
      ipAddress: [ v => Vue.prototype.Maglink.RulesIP(v) ]
    },
    networkSettings: [
      { index: 0, value: false, desc: i18n.t('Static IP') },
      { index: 1, value: true, desc: i18n.t('DHCP') }
    ]
  }),
  mounted () {
    this.Maglink.GetNetwork()
      .then(response => {
        this.network = response.data

        if (typeof this.Maglink.RulesIP(this.network.gateway) === 'string') {
          this.network.dhcp = true
        } else {
          this.network.dhcp = false
        }
      })
      .catch(error => (this.snack('error', error.message)))
  },
  methods: {
    onSave (event) {
      if (this.$refs.form.validate()) {
        this.isValidationOk = true
        this.Maglink.SetNetwork(this.network)
          .then(response => {
            this.snack('success', response.data['done'])
          })
          .catch(error => (this.snack('error', error.message)))
      } else {
        this.isValidationOk = false
      }
    },
    snack (color, message) {
      message = this.title + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
